import { render, staticRenderFns } from "./PublicationPagesInTheEditionCard.vue?vue&type=template&id=c662ff24&scoped=true"
import script from "./PublicationPagesInTheEditionCard.vue?vue&type=script&lang=js"
export * from "./PublicationPagesInTheEditionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c662ff24",
  null
  
)

export default component.exports